import { useState, useEffect } from 'react';
import { ECSJobsTable } from './ECSJobsTable';
import { ECSJob } from '../types';
import { fetchECSJobs } from '../api';

export function ECSJobsView() {
  const [jobs, setJobs] = useState<ECSJob[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    loadJobs();
  }, []);

  const loadJobs = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchECSJobs();
      setJobs(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load ECS jobs');
    } finally {
      setLoading(false);
    }
  };

  const handleRowClick = (job: ECSJob) => {
    // TODO: Open job detail modal when implemented
    console.log('Job clicked:', job);
  };

  return (
    <ECSJobsTable
      jobs={jobs}
      loading={loading}
      error={error}
      onRowClick={handleRowClick}
    />
  );
}
